import type {BackgroundTaskAction} from 'src/action-creators/background-task';
import type {
  BackgroundTaskStatus,
  BackgroundTask,
} from 'src/types/background-task';

import {RECEIVE, RECEIVE_POLLING} from 'src/action-creators/background-task';


export type {BackgroundTaskStatus};

export type TasksByKey = {
  [key: string]: BackgroundTask;
};

export type PollingTimersByKey = {
  [key: string]: boolean;
};

export type BackgroundTaskState = {
  data: TasksByKey;
  polling: PollingTimersByKey;
};

const initialState = {
  data: Object.freeze({}),
  polling: Object.freeze({}),
} as const;

export default (
  state: BackgroundTaskState | null | undefined = initialState,
  action: BackgroundTaskAction,
): BackgroundTaskState => {
  switch (action.type) {
    case RECEIVE:
      // @ts-expect-error - TS2322 - Type '{ data: { [x: string]: BackgroundTask; }; polling?: PollingTimersByKey | undefined; }' is not assignable to type 'BackgroundTaskState'.
      return {
        ...state,
        // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
        data: {...state.data, [action.payload.key]: action.payload},
      };

    case RECEIVE_POLLING:
      return {
        ...state,
        // @ts-expect-error - TS2322 - Type '{ [x: string]: boolean | BackgroundTaskPollingStatus; }' is not assignable to type 'PollingTimersByKey'.
        polling: {
          // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
          ...state.polling,
          [action.payload.key]: action.payload,
        },
      };
  }

  // @ts-expect-error - TS2322 - Type 'BackgroundTaskState | null' is not assignable to type 'BackgroundTaskState'.
  return state;
};
